import { useState } from 'react';

import { Button, Icon } from '@components';
import { META_ACCESS_TOKEN_VARIANT } from '@features/lead-management/constants/leadSettings';

import MetaAccessTokenModal from './MetaAccessTokenModal';
import { getStepKey, StepItem, STEPS } from './MetaAccessTokenSteps';

import theme from '../../../../../themes/colors';

interface MetaAccessTokenBannerProps {
  variant?: 'accordion' | 'modal';
  wrapperClassName?: string;
  bannerClassName?: string;
}

const MetaAccessTokenBanner = ({
  variant = META_ACCESS_TOKEN_VARIANT.MODAL,
  wrapperClassName = '',
  bannerClassName = ''
}: MetaAccessTokenBannerProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isAccordion = variant === META_ACCESS_TOKEN_VARIANT.ACCORDION;

  const handleClick = () => {
    if (isAccordion) {
      setIsExpanded(!isExpanded);
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <div
        className={`h-[42px] w-full rounded-[8px] bg-cofeeNeutralBg ${wrapperClassName}`}
      >
        <Button
          variant="transparent"
          handleClick={handleClick}
          className={`size-full !justify-between gap-2 !bg-transparent !py-2 ${bannerClassName}`}
        >
          <div className="flex items-center gap-2">
            <Icon
              name="alert-circle"
              className="size-4 shrink-0"
              stroke={theme.cofeeNeutral8}
            />
            <span className="text-[14px] font-medium leading-[100%] tracking-normal text-cofeeNeutral8">
              How to generate an access token?
            </span>
          </div>
          {isAccordion && (
            <Icon
              name="down-icon-dark"
              className={`mt-1 size-4 shrink-0 transition-transform duration-200 ${
                isExpanded ? 'rotate-180' : ''
              }`}
              stroke={theme.cofeeNeutral8}
            />
          )}
        </Button>
      </div>
      {isAccordion && isExpanded && (
        <div className="!mt-0 rounded-b-[8px] border-t border-cofeeNeutral4 bg-cofeeNeutralBg p-4">
          <ol className="flex flex-col gap-3 text-grey80">
            {STEPS.map((step, index) => (
              <StepItem
                key={getStepKey(step)}
                step={step}
                index={index}
                classNames={{
                  textClassOverride: '!text-sm',
                  permissionListClassName: '!bg-cofeeGreyBlue100'
                }}
              />
            ))}
          </ol>
        </div>
      )}
      {!isAccordion && (
        <MetaAccessTokenModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default MetaAccessTokenBanner;
